import { render, staticRenderFns } from "./UserTrendFilterInput.vue?vue&type=template&id=f598e988&scoped=true"
import script from "./UserTrendFilterInput.vue?vue&type=script&lang=ts"
export * from "./UserTrendFilterInput.vue?vue&type=script&lang=ts"
import style0 from "./UserTrendFilterInput.vue?vue&type=style&index=0&id=f598e988&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f598e988",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/user-trend/form/user-trend-filter-input.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fuser-trend%2Fform%2FUserTrendFilterInput.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports